import GroupStore from 'mewe/stores/group-store';
import { ds } from 'mewe/stores/ds';
import { isFeatureHintValid } from 'mewe/utils/feature-hint';
import { later } from '@ember/runloop';
import { loadDarkTheme } from 'mewe/utils/miscellaneous-utils';
import ChatApi from 'mewe/api/chat-api';
import FunctionalUtils from 'mewe/shared/functional-utils';

export const openGroupFtueDialog = (group, dynamicDialogs) => {
  dynamicDialogs.openDialog('group-initialisation-dialog', { group: group, doNotEscapeClose: true });
};

export const openFtueRecommendations = (dynamicDialogs, origin, callback) => {
  dynamicDialogs.openDialog('discover-interests-dialog', {
    origin: origin,
    useDarkTheme: origin === 'ftue',
    doNotEscapeClose: origin === 'ftue',
    callback,
  });
};

export const openPostbox = (params, dynamicDialogs) => {
  // we used to open postbox with preselected group by just passing groupId
  if (params.groupId && !params.preselectedGroup) {
    params.preselectedGroup = GroupStore.getState({ id: params.groupId });
  }

  if (params.eventId && !params.preselectedEvent) {
    params.preselectedEvent = ds.events.for('all-events').items.find((i) => i.id === params.eventId);
  }

  dynamicDialogs.openDialog('postbox-dialog', params);
};

export const showGroupJoinedDialog = (dynamicDialogs, group) => {
  dynamicDialogs.openDialog('group-joined-dialog', {
    group,
  });
};

export const showNewToMeWePopup = (dynamicDialogs) => {
  dynamicDialogs.openDialog('new-to-mewe-dialog');
};

// FTUE should be started on first Home feed visit after registration,
// but it's postponed if case there is Group Preview dialog displayed on first opening.
// In such case FTUE is started after Group Preview dialog is closed or until second visit
// to Home feed (if user joined group in the dialog and was redirected to group feed).
export const startFtue = (dynamicDialogs) => {
  // this load is run also during app initialisation so probably it's already loaded
  loadDarkTheme().then(() => {
    // timeout is needed because ftue is triggered during route transitions and we
    // need to wait at least fot the location to be changed because it's checked here
    later(
      this,
      () => {
        // show Premium Trial and whole FTUE only on Myworld page
        if (!~window.location.pathname.indexOf('/myworld')) {
          return;
        }

        isFeatureHintValid('premium-new-user-ad').then(({ timesViewed }) => {
          if (timesViewed === 0) {
            dynamicDialogs.openDialog('store/store-item-premium-dialog', {
              context: 'onboarding',
              isFtueFlow: true,
              useDarkTheme: true,
              onClose: () => {
                document.querySelector('.app-dragover-overlay').classList.remove('active');
                if ('scrollRestoration' in history) {
                  history.scrollRestoration = 'auto';
                  document.querySelector('html').style.overflow = 'auto';
                }
              },
            });
          }
        });
      },
      500
    );
  });
};

export const showGroupPreviewDialog = (dynamicDialogs, group, options = {}) => {
  dynamicDialogs.openDialog('group-preview-dialog', {
    groupFromParent: group,
    options,
  });
};

export const repostMediaToChat = (params, dynamicDialogs) => {
  dynamicDialogs.openDialog('chat-candidates-dialog', {
    title: __('Send to Chat'),
    saveText: __('Send'),
    submitAction: async (users, groups, threads) => {
      let thread = threads[0];
      // assuming that sharing can be done only to one thread
      if (!thread) {
        if (users.length) {
          const usersIds = users.map((user) => user.id);
          thread = await ChatApi.createChatThread({
            receivers: usersIds,
          });
        } else if (groups.length) {
          thread = groups[0];
        }
      }

      try {
        if (params.message) {
          await ChatApi.sendMessage(thread.id, params);
        } else {
          const possibleKeys = ['mediaIds', 'fileIds', 'audioIds'];
          const key = possibleKeys.find((k) => params[k]);
          // sending media one by one because we don't handle messages with multiple medias yet
          await Promise.all(params[key].map(async (mediaId) => {
            await ChatApi.sendMessage(thread.id, {
              [key]: [mediaId],
            });
          }));
        }
        FunctionalUtils.info(__('Message sent'));
      } catch (error) {
        if (error.data?.errorCode === 623) {
          FunctionalUtils.showLimitedPostingNotice();
        } else {
          FunctionalUtils.error(__('Failed to send message'));
        }
      }
    },
  });
}
